import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { Box, Button, Typography } from "@mui/material";

interface MinimumPriceAlertProps {
  openInfo: any;
  handleClose: any;
}

const ClaimServiceAlert: React.FC<MinimumPriceAlertProps> = ({
  openInfo,
  handleClose,
}) => {
  return (
    <React.Fragment>
      <Dialog
        open={openInfo}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
        fullWidth
      >
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography
              variant="body1"
              sx={{ color: "red", fontWeight: "bold" }}
            >
              Error
            </Typography>
          </Box>
          <br />
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="body1" sx={{ color: "black" }}>
              You must remove the claimed service from the cart before adding
              another one.
              <br />
              <br />
              <br />
              If you&#39;ve already taken a claimed service, you&#39;ll need to
              wait at least 7 days before adding another claimed service to your
              cart.
            </Typography>
          </Box>
          <br />
          <Box
            sx={{
              display: "flex",
              justifyContent: "right",
              alignItems: "center",
            }}
          >
            <Button variant="contained" color="success" onClick={handleClose}>
              ok
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default ClaimServiceAlert;
